<s-ori-page-template>
  <router-outlet></router-outlet>
</s-ori-page-template>
